// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateAttention } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { AddressFieldDisplayModel } from "@insite/client-framework/Types/ApiModels";
import isEmpty from "lodash/isEmpty";

const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);

export const xValidateAttention: typeof ValidateAttention = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { attention } = props.parameter.address;
    if (
        // XNG-Changes: ?.attention
        addressFieldDisplayCollection?.attention?.isVisible &&
        validationRules.attention?.isRequired &&
        isEmpty(attention)
    ) {
        props.addressErrors.attention = getRequiredErrorMessage(addressFieldDisplayCollection.attention);
    }
};

replaceInChain(chain, ValidateAttention, xValidateAttention);
